import Layout from '@/components/layout.vue'
import LayoutCenter from '@/components/layoutCenter.vue'
import LayoutHome from "@/components/layoutHome.vue";
import LayoutWrongBook from "@/components/layoutWrongBook.vue";
const router_modular = [{
        path: '/',
        name: 'rootPath',
        redirect: '/home'
    },
    {
        path: '/largeScreenIndex',
        component: (resolve) => require(['@/views/largeScreenIndex/index.vue'], resolve),
        name: 'largeScreenIndex',
    },
    {
        path: '/page',
        component: Layout,
        hidden: true,
        children: [{
                path: '/sel',
                name: 'sel',
                component: () => import('@/views/login/selRoleLogin.vue')
            },
            {
                path: '/login',
                name: 'login',
                component: () => import('@/views/login/index.vue')
            }, {
                path: '/register',
                name: 'register',
                component: () => import('@/views/register/index.vue')
            },
            // {
            //     path: '/home',
            //     name: 'home',
            //     component: () => import('@/views/home/index.vue')
            // },
            {
                path: '/news',
                name: 'news',
                component: () => import('@/views/news/index.vue')
            }, {
                path: '/newsDetail',
                name: 'newsDetail',
                component: () => import('@/views/news/detail.vue')
            }, {
                path: '/apps',
                name: 'apps',
                component: () => import('@/views/apps/index.vue')
            }, {
                path: '/appsDetail',
                name: 'appsDetail',
                component: () => import('@/views/apps/detail.vue')
            }, {
                path: '/aboutUs',
                name: 'aboutUs',
                component: () => import('@/views/aboutUs/index.vue')
            },
            {
                path: '/foundPassword',
                name: 'foundPassword',
                component: () => import('@/views/foundPassword/index.vue')
            },
            {
                path: '/setPwd',
                name: 'setPwd',
                component: () => import('@/views/home/setPassword.vue')
            },
             
        ]
    },
    {
        path: '/home',
        component: LayoutHome,
        hidden: true,
        children: [{
            path: '/home',
            name: 'home',
            component: () => import('@/views/home/index.vue')
        }, {
            path: '/valueAdded',
            name: 'valueAdded',
            component: () => import('@/views/valueAdded/index.vue')
        }]
    },
    {
        path: '/center',
        component: LayoutCenter,
        hidden: true,
        children: [{
                path: '/center',
                name: 'center',
                component: () => import('@/views/center/index.vue'),
                redirect: '/notice',
            }, {
                path: '/notice',
                name: 'noticePage',
                component: () => import('@/views/center/notice/index.vue')
            },
            {
                path: '/noticeDetail',
                name: 'noticeDetail',
                component: () => import('@/views/center/notice/detail.vue')
            },
            {
                path: '/myApp',
                name: 'myApp',
                component: () => import('@/views/center/myApp/index.vue')
            },
            {
                path: '/message',
                name: 'message',
                component: () => import('@/views/center/message/index.vue'),
                redirect: '/message//message',
                children: [{
                    path: '/message/message',
                    name: 'messagePage',
                    component: () => import('@/views/center/message/message.vue')
                }, {
                    path: '/message/task',
                    name: 'taskPage',
                    component: () => import('@/views/center/message/task.vue')
                }]
            },
            {
                path: '/account',
                name: 'account',
                component: () => import('@/views/center/account/index.vue'),
                redirect: '/account/info',
                children: [{
                    path: '/account/info',
                    name: 'accountInfo',
                    component: () => import('@/views/center/account/info.vue')
                }, {
                    path: '/account/set',
                    name: 'accountSet',
                    component: () => import('@/views/center/account/set.vue')
                }, {
                    path: '/account/editpwd',
                    name: 'accountEditpwd',
                    component: () => import('@/views/center/account/editpwd.vue')
                }]
            },
            {
                path: '/myClass',
                name: 'myClassPage',
                component: () => import('@/views/center/account/myClass.vue')
            },
            {
                path: '/mySummary',
                name: 'mySummaryPage',
                component: () => import('@/views/center/account/summary.vue')
            },
        ]
    },
    {
        path: '/wrongBook',
        component: LayoutWrongBook,
        hidden: true,
        children: [{
            path: '/wrongBook',
            name: 'wrongBook',
            component: () => import('@/views/wrongBook/index.vue')
        }]
    },

]
export default router_modular